import { render, staticRenderFns } from "./XlForm.vue?vue&type=template&id=16f5ebd4&scoped=true"
import script from "./XlForm.vue?vue&type=script&lang=js"
export * from "./XlForm.vue?vue&type=script&lang=js"
import style0 from "./XlForm.vue?vue&type=style&index=0&id=16f5ebd4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16f5ebd4",
  null
  
)

export default component.exports